// Lightweight WebAudio notification chime + per-device mute preference.
// No audio file needed; synthesizes a soft two-note "ding".

const MUTE_KEY = 'hb_sound_muted';
let audioCtx = null;
let lastPlayed = 0;

export function isSoundMuted() {
  return localStorage.getItem(MUTE_KEY) === '1';
}

export function toggleSoundMuted() {
  const next = !isSoundMuted();
  localStorage.setItem(MUTE_KEY, next ? '1' : '0');
  if (!next) ensureContext(); // resuming while unmuting counts as a user gesture
  return next;
}

function ensureContext() {
  try {
    if (!audioCtx) {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return null;
      audioCtx = new Ctx();
    }
    if (audioCtx.state === 'suspended') audioCtx.resume().catch(() => {});
    return audioCtx;
  } catch (e) {
    return null;
  }
}

// Browsers require a user gesture before audio can play. Resume on first interaction.
if (typeof window !== 'undefined') {
  const resume = () => ensureContext();
  window.addEventListener('pointerdown', resume, { once: true });
  window.addEventListener('keydown', resume, { once: true });
}

export function playNotificationSound() {
  if (isSoundMuted()) return;
  const now = Date.now();
  if (now - lastPlayed < 800) return; // debounce bursts
  lastPlayed = now;

  const ctx = ensureContext();
  if (!ctx || ctx.state !== 'running') return;

  const t = ctx.currentTime;
  const master = ctx.createGain();
  master.gain.value = 0.0001;
  master.connect(ctx.destination);
  // gentle envelope
  master.gain.exponentialRampToValueAtTime(0.18, t + 0.02);
  master.gain.exponentialRampToValueAtTime(0.0001, t + 0.55);

  // two notes: C6 then E6 for a pleasant "ding"
  [[1046.5, t, 0.35], [1318.5, t + 0.12, 0.4]].forEach(([freq, start, dur]) => {
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.value = freq;
    g.gain.value = 0.0001;
    g.gain.exponentialRampToValueAtTime(1, start + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
    osc.connect(g);
    g.connect(master);
    osc.start(start);
    osc.stop(start + dur + 0.05);
  });
}
